import Typed from 'typed.js';

document.addEventListener('turbo:load', () => {
  const typedElement = document.querySelector('#typed-element');
  if (typedElement) {
    const options = {
      strings: [
        'by city!',
        'by state, province, or region!',
        'by country!',
        'by continent!',
        'by dance style!',
        'by month/year!',
      ],
      typeSpeed: 30,
      backSpeed: 30,
      smartBackspace: true, // this is a default
      loop: true,
      shuffle: true,
    };
    new Typed('#typed-element', options);
  }
});
